module.exports = __webpack_public_path__ + "img/wells-closed.84c7eb38.svg";